export const NOTIFICATION_SERVICE = "notificationService";

export class NotificationService {
    
    static $inject = ["$mdToast"];
    constructor(private $mdToast: ng.material.IToastService) { }

    show(text: string) {
        return this.$mdToast.show(
            this.$mdToast
                .simple()
                .position("top right")
                .textContent(text)
        );
    }

    error(errorMessage: string): any {
        this.$mdToast
            .show({
                template: `<md-toast class="md-toast"><div class="md-toast-content" style="background-color: red; box-shadow: 0">${errorMessage}</div></md-toast>`,
                position: "top right",
                hideDelay: 5000
            });
    }
}


// WEBPACK FOOTER //
// ./app/core/notification.service.ts